import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { IConfig } from '@amt/i-config';
import { IDomain } from '@amt/i-domain';
import { IEmailTemplate } from '@amt/i-email-template';

import {
    Blocker,
    LoadBlockerService,
} from 'bkng';

import { EnvService } from '@s/env.service';
import { IAddConfigDialogData } from '../add-config-dialog/add-config-dialog.component';

import { DomainService } from '@s/domain.service';
import { IEnv } from '@alt/i-env';
import { DomainAvailableConfigsGetResult } from '@api-routes/domain/types/domain-available-configs-get-result';

@Component({
    selector: 'app-domain-configs-view',
    templateUrl: './domain-configs-view.component.html',
    styleUrls: ['./domain-configs-view.component.scss']
})
export class DomainConfigsViewComponent implements OnInit {
    addConfigData: IAddConfigDialogData = {
        configTypeName: 'domain',
        getAvailableConfigs: () => {
            return this.getAvailableConfigs();
        }
    };
    blocker: Blocker;
    configs: Array<IConfig> = [];
    domain: IDomain;
    emailTemplates: Array<IEmailTemplate> = [];
    env: IEnv;

    constructor (
        public envService: EnvService,
        public lbs: LoadBlockerService,
        public domainService: DomainService,
        public route: ActivatedRoute,
    ) {
        this.env = envService.data;
        this.blocker = lbs.register({});

        this.fetch().catch(console.error).finally(() => {
            this.blocker.unblock();
        });
    }

    async addConfig (config: IConfig): Promise<IConfig> {
        return await this.domainService.addConfig({
            domainId: this.domain.id,
            configId: config.id,
        }).then(async (result) => {
            await this.fetch();
            return result.config;
        });
    }

    fetch (): Promise<void> {
        return this.domainService.getById({
            id: <string>(this.route.snapshot.params.domainId),
            merchantId: <string>(this.route.snapshot.params.merchantId),
            organizationId: <string>(this.route.snapshot.params.organizationId),
        }).then((res) => {
            console.log(res);
            Object.assign(this, res);
            return Promise.resolve();
        });
    }

    getAvailableConfigs (): Promise<DomainAvailableConfigsGetResult> {
        return this.domainService.getAvailableConfigs({
            domainId: <string>(this.route.snapshot.params.domainId)
        });
    }

    ngOnInit (): void {
    }
}
